import React from 'react';

const DeclaracaoImportacaoContext = React.createContext();

export default DeclaracaoImportacaoContext;
